import { useState } from 'react';

export default function useOpen(initialValue = false) {
  const [isOpen, setIsOpen] = useState(initialValue);
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  return [isOpen, onOpen, onClose];
}
